<template>
    <div class="rr-checkout__step rr-checkout__step_shipping" v-show="active">
        <div class="uk-grid-small" uk-grid>
            <div class="uk-width-1-1 uk-text-center uk-text-left@m">
                <p class="uk-h3">{{ $t('rubinred.ecommerce.orders.checkout.step-2.title') }}</p>
            </div>
            <div class="uk-width-1-1">
                <div class="rr-checkout__wrapper">
                    <div class="rr-checkout__content">
                        <ul class="rr-checkout-accordion uk-margin-remove" ref="accordion">
                            <li class="rr-checkout-accordion__section" v-for="method in methods">
                                <div class="rr-checkout-accordion__title">
                                    <div class="rr-checkout-accordion__title-left">
                                        <label class="rr-checkout-accordion__title-label">
                                            <input type="radio" class="uk-checkbox" name="shipping_method" :value="method.slug" v-model="selectedShipping">
                                            <span class="rr-checkout-accordion__title-content">
                                                <span class="rr-checkout-accordion__title-title">{{ method.name }}</span>
                                                <span class="rr-checkout-accordion__title-text" v-if="method.description">
                                                    {{ method.description }}
                                                </span>
                                            </span>
                                        </label>
                                    </div>
                                    <div class="rr-checkout-accordion__title-right" v-if="method.price">
                                        <p>{{ Utils.Currencies.toHuman(method.price) }}</p>
                                    </div>
                                </div>
                                <div class="rr-checkout-accordion__content uk-accordion-content">
                                    <slot :name="method.slug"></slot>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="uk-width-1-1">
                <div class="rr-checkout__wrapper">
                    <div class="rr-checkout__content">
                        <div class="uk-form-stacked">
                            <form-textarea
                                    name="notes"
                                    slug="notes"
                                    :label="$t('rubinred.ecommerce.orders.checkout.notes')"
                                    :placeholder="$t('rubinred.ecommerce.orders.checkout.placeholders.notes')"
                                    :value="notes"
                                    ref="notes"
                            >
                            </form-textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import CheckoutStep from 'rubinred/ecommerce/js/mixins/CheckoutStep'

  export default {
    mixins: [CheckoutStep],
    props: {
      methods: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        accordion: null,
        selectedShipping: this.$store.state.checkout.shipping.method ? this.$store.state.checkout.shipping.method.slug : null,
        handlers: {},
      };
    },
    watch: {
      selectedShipping() {
        this.accordion.toggle(this.methods.findIndex(method => method.slug === this.selectedShipping))
      }
    },
    computed: {
      notes() {
        return this.$store.state.cart.cart ? this.$store.state.cart.cart.notes : null;
      },
    },
    updated() {
      if (!this.active) {
        return;
      }
      if (!this.accordion) {
        this.accordion = window.App.UIkit.accordion(this.$refs.accordion);
        if (this.selectedShipping) {
          this.accordion.toggle(this.methods.findIndex(method => method.slug === this.selectedShipping))
        }
      }
    },
    methods: {
      submit() {
        let handler = this.handlers[this.selectedShipping];
        if (handler && handler.validate()) {
          return window.App.Axios.post(this.endpoint, {
            notes: this.$refs.notes.getValue(),
            ...handler.getData(),
            method: this.selectedShipping
          }).then(response => {
            if (response.data.success) {
              this.$store.commit('cart/update', response.data.cart);
              this.$store.commit('checkout/setShippingData', {
                ...response.data.shipping,
                method: this.methods.find(method => method.slug === this.selectedShipping),
              });
            }

            return response;
          });
        }

        return false;
      },
      registerHandler(handler) {
        this.handlers[handler.slug] = handler;
      }
    },
    provide: function () {
      return {
        registerHandler: this.registerHandler,
      };
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/steps/RubinredCheckoutShippingStep.vue